import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { ItemDataPayload, ItemDataResponse } from "@/types/interface/item";
import { ref } from "vue";
import { db } from "@/database/db";

const loginInfo = ref();
const stringLoginInfo = await db.storage.get("login-info")!;
loginInfo.value = stringLoginInfo?.data;

async function createItem(payload: ItemDataPayload) {
  return await http.post<APIResponse<ItemDataResponse>>("goods/create", payload);
}

async function updateItem(iditem = '', payload: ItemDataPayload) {
  return await http.patch<APIResponse<ItemDataResponse>>(`goods/update?id=${iditem}`, payload);
}

async function getItem(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<ItemDataResponse>>(`goods?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function getCatalog(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  if (loginInfo?.value?.job?.id != undefined){
    queryParam = queryParam + '&job_id=' + loginInfo?.value?.job?.id;
  }
  return await http.get<APIResponse<ItemDataResponse>>(`goods/catalog?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findItem(iditem = "") {
  return await http.get<APIResponse<ItemDataResponse>>(`goods/detail?id=${iditem}`);
}

async function deleteItem(iditem = "") {
  return await http.delete<APIResponse<ItemDataResponse>>(`goods/delete?id=${iditem}`);
}

async function importItem(payload: any) {
  return await http.post<APIResponse<ItemDataResponse>>("goods/import", payload);
}

async function downloadImportFormat() {
  return await http.get<APIResponse<ItemDataResponse>>("goods/download-import-format");
}

export default {
  createItem,
  updateItem,
  getItem,
  getCatalog,
  findItem,
  deleteItem,
  importItem,
  downloadImportFormat,
};